import { dpApiV2 } from "./apiV2";

export type User = {
  name: string;
  email: string;
  id: number;
  is_admin: boolean;
  is_charity_admin: boolean;
  is_retailer_admin: boolean;
  is_end_user: boolean;
}

type ValidateEmailRequest = {
  email: string,
}

type ValidateDetailsResponse = {
  error?: string,
  message?: string,
}

const extendedApi = dpApiV2.injectEndpoints({
  endpoints: builder => ({
    getCurrentUser: builder.query<User, string>({
      query: body => ({
        url: "accounts/legacy-user/current/",
        responseHandler: async response => {
          const resJson = await response.json();
          return resJson;
        },
      }),
      providesTags: [ "User" ]
    }),
    validateEmail: builder.query<ValidateDetailsResponse, ValidateEmailRequest>({
      query: body => ({
        url: "accounts/validate-email/",
        method: "POST",
        body
      }),
    }),
    loginWithEmailAndPassword: builder.mutation<{ success: boolean; session_id: string; }, { email: string; password: string; }>({
      query: body => ({
        method: "POST",
        url: "accounts/legacy-user/login/",
        body
      }),
      invalidatesTags: [ "User" ]
    }),
    loginWithTmpPass: builder.mutation<{ success: boolean; session_id: string; }, { id: number; password: string; }>({
      query: body => ({
        method: "POST",
        url: "accounts/legacy-user/login_with_tmp_pass/",
        body
      }),
      invalidatesTags: [ "User" ]
    }),
    logOut: builder.mutation<{ success: boolean; }, any>({
      query: body => ({
        method: "GET",
        url: "accounts/legacy-user/logout/"
      }),
      invalidatesTags: [ "User" ]
    }),
    loginAsUser: builder.mutation<{ success: boolean; session_id: string; }, number>({
      query: userId => ({
        url: "accounts/log-in-as-user/",
        method: "POST",
        body: { id: userId }
      }),
      invalidatesTags: [ "User" ]
    }),
    sendPasswordResetEmail: builder.mutation<{ success: boolean }, { email: string; }>({
      query: body => ({
        method: "POST",
        url: "accounts/legacy-user/reset_password/",
        body
      })
    }),
    updateUser: builder.mutation<{
      success: boolean
    }, {
      email?: string;
      password?: string;
      old_password?: string;
      tmp_password?: string;
      user_id: number;
    }>({
      query: body => ({
        method: "PATCH",
        url: `accounts/legacy-user/${body.user_id}/`,
        body
      }),
      invalidatesTags: [ "User", "Charity" ]
    }),
  })
});

export const {
  useGetCurrentUserQuery,
  useLazyValidateEmailQuery,
  useLoginWithEmailAndPasswordMutation,
  useLoginWithTmpPassMutation,
  useLogOutMutation,
  useLoginAsUserMutation,
  useSendPasswordResetEmailMutation,
  useUpdateUserMutation
} = extendedApi;
